export default __webpack_public_path__ + "static/desktop_menu_KV13-0729d0e5972a00fbefb9d9de990209e4.mp4";